/** Return a navigation-safe same-origin HTTP(S) path, or null. */
export const toSameOriginPath = (target: string): string | null => {
  try {
    const url = new URL(target, window.location.origin);
    if (
      (url.protocol !== 'http:' && url.protocol !== 'https:') ||
      url.origin !== window.location.origin
    ) {
      return null;
    }
    // A same-origin absolute URL can have a // pathname, which becomes an
    // off-origin network-path reference when assigned without its origin.
    if (url.pathname.startsWith('//')) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    // swallow-ok: Malformed return URLs fail closed; callers use their same-origin fallback.
    return null;
  }
};
